import { Billing, OfficeBalance } from "@/type/core/offices/offices.types";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, Select } from "antd";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";
import { formatPriceWithEuro } from "@utils/helpers/format-helper";

const TARIFS = [
  10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 250, 300, 350, 400, 450, 500,
  1000, 1500, 2000,
];

const DEFAULT_TARIF = 50;

interface OrderModalProps extends BasicModalProps {
  officeBalance?: OfficeBalance;
  billing: Billing;
  onSubmit: (tarif: number) => void;
  defaultTarif?: number;
}

const OrderModal: FunctionComponent<OrderModalProps> = ({
  officeBalance,
  billing,
  onSubmit,
  defaultTarif,
  ...props
}) => {
  const solde = (officeBalance?.balanceInCents ?? 0) / 100;

  const { t } = useTranslation();

  const [selectedTarif, setSelectedTarif] = useState<number>(
    defaultTarif ?? DEFAULT_TARIF,
  );

  return (
    <BasicModal
      onOk={() => onSubmit(selectedTarif)}
      buttonText={t("modals.orderModal.credit")}
      {...props}
    >
      <div>
        <Row>
          <Col sm="12">
            <div className={"text-danger mb-16"}>
              <FontAwesomeIcon icon={faExclamationTriangle} className="mr-4" />
              {t("modals.orderModal.popup", { officeName: billing.officeName })}
            </div>
            <div>{(billing.officeName ?? "").toUpperCase()}</div>
            <div>{(billing.address1 ?? "").toUpperCase()}</div>
            <div>{(billing.address2 ?? "").toUpperCase()}</div>
            <div>
              {billing.zipCode + " " + (billing.city ?? "").toUpperCase()}
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="w-100" sm="12">
            <hr className="w-100" />
            <p
              data-test="input-label"
              data-alt={t("modals.orderModal.selectLabel")}
              data-test-for="priceSelection"
            >
              {t("modals.orderModal.selectLabel")}
            </p>
            <Select
              popupMatchSelectWidth={false}
              value={selectedTarif}
              data-test="priceSelection"
              onChange={(value: number) => setSelectedTarif(value)}
            >
              {TARIFS.map((tarifValue) => (
                <Select.Option
                  key={tarifValue}
                  className="text-center"
                  value={tarifValue}
                  data-test="select-list-option"
                  selected={tarifValue === selectedTarif}
                >
                  {`${tarifValue}€`}
                </Select.Option>
              ))}
            </Select>
            <div className={"text-danger mb-16 mt-16  "}>
              <FontAwesomeIcon icon={faExclamationTriangle} className="mr-4" />
              {t("modals.orderModal.warningInformation", {
                officeName: billing.officeName,
              })}
            </div>
            <Row>
              {t("modals.orderModal.solde") + formatPriceWithEuro(solde)}
            </Row>
            <Row>
              {t("modals.orderModal.newSolde") +
                formatPriceWithEuro(solde + selectedTarif)}
            </Row>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default OrderModal;
